module.exports = __webpack_public_path__ + "fonts/Golos-Text_Regular.6f98282.eot";